import BASE_API from "../../shared/utility/base-api"

export const DASHBOARD_ENDPOINT = {
  countProperties: `${BASE_API}/properties/get-properties`,
  countTenants: `${BASE_API}/tenants/get-tenants`,
  countUnits: `${BASE_API}/properties/get-units`,
  countOwners: `${BASE_API}/owners/get-owners`,
  countLeases: `${BASE_API}/leases/get-leases`,
  countRequests: `${BASE_API}/requests/get-requests`,

  groupTenantsByCreatedDate: `${BASE_API}/tenants/group-tenants-by-created-date`,
  groupLeasesByCreatedDate: `${BASE_API}/leases/group-leases-by-created-date`,
  groupLeasesByStatus: `${BASE_API}/leases/group-leases-by-status`,
  getTotalLeasePayments: `${BASE_API}/leases/get-total-lease-payments`,
  getCurrentMonthsTotalLeasePayments: `${BASE_API}/leases/get-current-months-total-lease-payments`,
  getExpiringLeasesThisMonth: `${BASE_API}/leases/get-expiring-leases-this-month`,
  countExpiredLeases: `${BASE_API}/leases/count-expired-leases`,
  countVacantUnits: `${BASE_API}/leases/count-vacant-units`,
  countOccupiedUnits: `${BASE_API}/leases/count-occupied-units`,
  getTotalPayments: `${BASE_API}/payments/get-total-payments`,
  getCurrentMonthsTotalPayments: `${BASE_API}/payments/get-current-months-total-payments`,
  getMonthlyLeaseExpirations: `${BASE_API}/leases/get-monthly-lease-expirations`,
  getTotalLeasePaymentsForPeriod: `${BASE_API}/leases/get-total-lease-payments-for-period`,
  // getTotalPayments: `${BASE_API}/payments/get-total-payments`,
  countUnitDistribution: `${BASE_API}/leases/count-vacant-and-occupied-units`,
}